import React from 'react';
import { useState, useContext } from 'react';
import Cookies from 'js-cookie';
import axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';
import { GlobalContext } from '../context/GlobalContext';

const RegisterPage = () => {
  const navigate = useNavigate();
  const [input, setInput] = useState({
    name: '',
    image_url: '',
    email: '',
    password: '',
  });

  const handleChange = (event) => {
    let value = event.target.value;
    let name = event.target.name;

    setInput({ ...input, [name]: value });
  };

  const handleRegister = (event) => {
    event.preventDefault();

    let { image_url, name, email, password } = input;

    axios
      .post('https://dev-example.sanbercloud.com/api/register', {
        image_url,
        name,
        email,
        password,
      })
      .then((res) => {
        let data = res.data;
        console.log(res);
        Cookies.set('token', data.token, { expires: 1 });
        Cookies.set('user', JSON.stringify(data.user), { expires: 1 });
        navigate('/');
      })

      .catch((error) => {
        // console.log(error)
        alert(error.message);
      });
  };

  return (
    <div className="d-flex justify-content-center">
      <form onSubmit={handleRegister}>
        <div className=" col-12">
          <label htmlFor="email" className="form-label">
            Email
          </label>
          <input
            type="text"
            name="email"
            className="form-control"
            onChange={handleChange}
            value={input.email}
            placeholder="Email..."
          />
        </div>
        <div className=" col-12">
          <label htmlFor="name" className="form-label">
            Nama
          </label>
          <input
            type="text"
            name="name"
            className="form-control"
            onChange={handleChange}
            value={input.name}
            placeholder="Nama..."
          />
        </div>
        <div className=" col-12">
          <label htmlFor="image_url" className="form-label">
            Image URL
          </label>
          <input
            type="text"
            name="image_url"
            className="form-control"
            onChange={handleChange}
            value={input.image_url}
            placeholder="Link image..."
          />
        </div>

        <br />
        <div className=" col-12">
          <label htmlFor="password" className="form-label">
            Password
          </label>
          <input
            className="form-control"
            type="password"
            name="password"
            onChange={handleChange}
            value={input.password}
            placeholder="Password..."
          />
        </div>

        <p className="float-start mt-3">
          <Link to="/login">Login</Link>
        </p>
        <button
          className="btn btn-primary rounded-pill float-end mt-3"
          type="submit"
        >
          Submit
        </button>
      </form>
    </div>
  );
};

export default RegisterPage;
